import React from 'react';
import Store from '../redux/store';
import '../resources/css/home-main.scss';
import i18n from '../i18n';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from '../messenger/module';
import { Button } from '@material-ui/core';
import NoticePage from './notice-page';
import FeaturedDishes from '../components/home-components/featured-dishes.component';
import HomeMenuComponent from '../components/home-components/home-menu.component';
import OpeningHoursComponent from '../components/home-components/opening-hours.component';
import MediaComponent from '../components/home-components/media.component';
import DiningGuide from '../components/home-components/dining-guide.component';
import HeaderBar from '../components/home-components/header-bar.componemt';
import LiteFooterBar from '../components/home-components/lite-footer-bar.componemt';
import { isIphonex, PHONE_TYPE, preLoadNginxImage } from '../tools/utils';
import { DefaultRequest } from '../requests/default.request';
import { BusinessMenu, Menu, Propaganda, RestaurantInfo, TableStatus, NoticeData } from '../constants/type.constant';
import _ from 'lodash';
import axios from 'axios';

// 菜单默认图
import MenuSpeciale from '../assets/MENU_SPECIALE.jpg';
import MenuItemImg from '../assets/itemMenuBg.jpg';
import { ReduxConnect } from '../decorators/redux-connect.decorator';
import { States } from '../redux/type';

// 顶部公告条ICON
import InfoIcon from '@material-ui/icons/Info';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import ChatIcon from '@material-ui/icons/Chat';
import NotificationsIcon from '@material-ui/icons/Notifications';
import PhoneIcon from '@material-ui/icons/Phone';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import StarIcon from '@material-ui/icons/Star';
import { getSettingInfo } from '../tools/get-setting-info';
import { getCurrentBusinessMenu, isNewBusiness, isNewMenu, scheduleTransform } from '../constants/tools.constant';
import { PhotoSlider } from 'react-photo-view';
import { GMapGetcurrentLocation } from '../constants/tool-googlemap';
import moment from 'moment';
import { WebsocketClient } from '../websocket/module';
import { getSeverAndLoacalDiff } from '../tools/local-moment';

@ReduxConnect((defaultState: States, ownProps: Props) => {
    return {
        language: defaultState.language,
    };
})
class LiteHomePage extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    public scrollHomeViewTimeOut!: NodeJS.Timeout;
    public scrollCount = 0;
    public noticeAreaWidth: number = 0;
    constructor(props: Props) {
        super(props);
        this.state = {
            normalMenu: {} as Menu,
            specialMenu: [],
            isLoading: false,
            // 是否开启审核功能
            isApproved: true,
            // 是否开启自主点餐模式
            autonomous: {
                status: false
            },
            // 额外费用ID
            menuId: 0,
            // 当前桌台状态
            resultTableStatus: [],
            // 宣传资料数据
            propagandaData: [],
            // 餐馆信息
            restaurantInfo: {} as RestaurantInfo,
            // 首屏顶部公告条
            topBannerAnnouncement: [],
            // 普通公告图片(就餐指南)
            noticeData: [],
            // 活动公告
            isShowActivityBulletinArea: true,
            // 营业时间数据
            scheduleData: [],
            // 显示大图
            showGuidePic: false,
            // 当前的新营业时间还是旧营业时间
            isNew: false,
            // 禁用《立即点餐》按钮
            disabledOrderBtn: true
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    }

    // *********************
    // 生命周期
    // *********************

    public UNSAFE_componentWillMount() {
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'guidePageHideCard',
            value: false,
        })

        Store.dispatch({
            type: 'SET_CACHING',
            path: 'guidePageHideDishes',
            value: false,
        })

        Store.dispatch({
            type: 'SET_CACHING',
            path: 'guidePageHideHomeCard',
            value: false,
        })
        // 更新缓存中的图片加载随机数参数
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'imgRandomNumberParam',
            value: Math.random() * 100000,
        });
        WebsocketClient.addListener('MESSENGER', this.showMessenger);

    }
    public async componentDidMount() {
        // 获取服务器与本地时间戳差值
        const diffTimeStamp = await getSeverAndLoacalDiff();
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'diffTimeStamp',
            value: diffTimeStamp,
        })
        // 获取公告图片
        this.getnoticeImg();
        // 顶部公告信息条
        this.getBannerAnnouncement();
        this.getPropaganda();
        // 获取菜单
        await this.getSetting();
        // BMap获取当前位置
        const res = await GMapGetcurrentLocation();
        this.setState({ disabledOrderBtn: !!res })
        this.getRestaurantInfo();
    }
    public componentWillUnmount() {
        // document.removeEventListener('scroll', this.homeScrollView);
        WebsocketClient.removeListener('MESSENGER', this.showMessenger);
        this.setState = (state, callback) => { return; };
    }
    /**
     * showMessenger
     */
    public showMessenger = (data: { message: string, level: string }) => {
        try {
            this.messengerModule.say({
                message: data.message,
                level: data.level || "Warning",
            });
        } catch (error) { }
    }
    // 首屏顶部文字公告ICON字段
    public topBarIcon(item: string) {
        let iconName = '' as any;
        switch (item) {
            case 'el-icon-info':
                iconName = <InfoIcon />;
                break;
            case 'el-icon-price-tag':
                iconName = <LocalOfferIcon />;
                break;
            case 'el-icon-chat-line-square':
                iconName = <ChatIcon />;
                break;
            case 'el-icon-message-solid':
                iconName = <NotificationsIcon />;
                break;
            case 'el-icon-phone-outline':
                iconName = <PhoneIcon />;
                break;
            case 'el-icon-tickets':
                iconName = <ConfirmationNumberIcon />;
                break;
            case 'el-icon-message':
                iconName = <MailOutlineIcon />;
                break;
            case 'el-icon-time':
                iconName = <AccessTimeIcon />;
                break;
            case 'el-icon-star-on':
                iconName = <StarIcon />;
                break;
            default:
                iconName = <InfoIcon />;
                break;
        }
        return iconName;
    }
    /**
     *  获取顶部横幅公告条
     */
    public async getBannerAnnouncement() {
        try {
            const RES = await DefaultRequest.getBannerAnnouncement();
            if (Array.isArray(RES)) {
                let topAnnouncement = (_.chunk(RES, 3)[0]) ?? [];
                this.setState({ topBannerAnnouncement: topAnnouncement });
            }
        } catch (error) { }
    }

    /**
     * 获取自助开台菜单数据
     * @params currentMenu 当前菜单 长度为1的数组
     */
    public async getServiceData(currentMenu: BusinessMenu[], newMenu: boolean) {
        try {
            // 服务器地址
            let URL = Store.getState().serverUrl;
            // 首选菜单 只有一个
            let normalMenu = {} as Menu;
            // 备选菜单 可有多个
            let specialMenu: Menu[] = [];

            // 全部菜单
            let allMenu = [];

            if (Store.getState().cacheMenus.length) {
                allMenu = Store.getState().cacheMenus;
            } else {
                // 必选菜单
                const dishesSort = getSettingInfo('menu-dishes-sort', 'value');
                allMenu = await DefaultRequest.getMenus({ type: 0, dish_sort: dishesSort, with_dish: false })
            }

            // 获取首选菜单和备选菜单
            if (currentMenu && currentMenu.length > 0) {
                // 首选菜单 备选菜单 字符串格式
                let { preferred_menu, alternative_menu } = currentMenu[0];
                // 备选菜单 数组格式
                let originAlterNatibeMenu = alternative_menu.split(',');
                if (Array.isArray(allMenu)) {

                    for(let i = 0; i < allMenu.length; i++) {
                        const item = allMenu[i];
                        let groundId = `${item.main_group_id}`
                        // 首选菜单
                        if (groundId === preferred_menu) {
                            const img = `${URL}/first_menu/${item.main_group_id}.jpg`;
                            const newImg = await preLoadNginxImage(img, 'first_menu', 'menu');
                            _.set(item, 'url', newImg || MenuItemImg);
                            normalMenu = item;
                            this.setState({
                                normalMenu
                            })
                        }
                        // 备选菜单
                        else if (originAlterNatibeMenu.includes(groundId)) {
                            const img = `${URL}/first_menu/${item.main_group_id}.jpg`;
                            const newImg = await preLoadNginxImage(img, 'first_menu', 'menu');
                            _.set(item, 'url', newImg || MenuSpeciale);
                            specialMenu.push(item);
                            this.setState({
                                specialMenu
                            })
                        }
                    }
                }
            }
            // $ 新菜单价格
            if (newMenu) {
                // weekday 其中 1 是星期一、0 是星期日。
                const week = moment().weekday();
                if (Object.keys(normalMenu).length >= 0) {
                    const priceObj = _.find(normalMenu.value, (o) => { return o.week === week; });
                    normalMenu = { ...normalMenu, ...priceObj };
                }
                if (specialMenu.length > 0) {
                    specialMenu = specialMenu.map((v) => {
                        const priceObj = _.find(v.value, (o) => { return o.week === week; });
                        v = { ...v, ...priceObj };
                        return v
                    })
                }
            }

            this.setState({
                normalMenu,
                specialMenu
            });
            if (Object.keys(normalMenu).length === 0 && specialMenu.length === 0) {
                this.messengerModule.say({
                    message: `${i18n.t('auto_open_page_text_without_menu')}`,
                    level: 'Warning',
                })
            } else {
                this.setState({ isLoading: false });
            }
        } catch (err) {
            this.messengerModule.say({
                message: err as string,
                level: 'Warning',
            })
        }
    }

    /**
     * 判断设备机型号，赋值不同的class类名
     */
    public checkPhoneType() {
        if (isIphonex()) {
            return (
                PHONE_TYPE.indexOf('iPhone') > -1 && PHONE_TYPE.indexOf('Safari') > -1 ?
                    'home-main-ix' : 'home-main-android'
            );
        }
        else {
            return (
                PHONE_TYPE.indexOf('iPhone') > -1 && PHONE_TYPE.indexOf('Safari') > -1 ?
                    'home-main-ios' : 'home-main-android'
            );
        }
    }

    /**
     * 获取餐馆信息
     */
    public async getRestaurantInfo() {
        const RESTAURANT = await DefaultRequest.getRestaurantInfo();
        // console.log(RESTAURANT, 'RESTAURANT')
        if (Array.isArray(RESTAURANT)) {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'currency_name',
                value: RESTAURANT?.[0]?.currency_name || '€',
            })
            this.setState({
                restaurantInfo: _.get(RESTAURANT, '0', {
                    restaurant_name: "Smartway Restaurant",
                })
            });
        }
    }
    /**
     * 查询宣传资料
     */
    public async getPropaganda() {
        const PROPAGANDA = await DefaultRequest.getPropaganda();
        // console.log(PROPAGANDA, 'PROPAGANDA')
        if (Array.isArray(PROPAGANDA)) {
            this.setState({ propagandaData: PROPAGANDA });
        }
    }
    public getWebsite() {
        const IS_WEBSITE = this.state.propagandaData.find((item) => {
            return item.name === 'OFFICIAL_WEBSITE';
        });
        return IS_WEBSITE;
    }

    public async getSetting() {
        try {
            let settingInfo = await DefaultRequest.getSettingInfo();
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'settingInfo',
                value: settingInfo
            });
            // 自主点餐
            const AUTONOMOUS = settingInfo.find((target: any) => {
                return target.name === 'rule-autonomous-meal'
            })
            // 是否开启审核功能
            const ISAPPROVED = settingInfo.find((target: any) => {
                return target.name === 'open-table-audit'
            })
            // 额外费用id
            const MENUID = settingInfo.find((target: any) => {
                return target.name === 'package-fee'
            })
            MENUID && this.setState({ menuId: MENUID.value.menu_id })
            ISAPPROVED && this.setState({ isApproved: ISAPPROVED.value.enable })
            AUTONOMOUS && this.setState({ autonomous: AUTONOMOUS.value })
            // 营业时间
            let SCHEDULE: BusinessMenu[] = [];
            // 当前营业时间菜单
            let currentMenu: BusinessMenu[] = [];
            // 是否是新营业时间
            const isNew = isNewBusiness();
            if (isNew) {
                const result = await DefaultRequest.getBusinessHour2Project();
                SCHEDULE = scheduleTransform(_.get(result, '[0].value', []));
                currentMenu = getCurrentBusinessMenu(SCHEDULE)
            }
            // 旧营业时间
            else {
                SCHEDULE = await DefaultRequest.getBusinessHour();
                currentMenu = await DefaultRequest.getCurrentBusinessMenu();
            }
            // 是否是新一级菜单
            const newMenu = isNewMenu();
            this.setState({
                scheduleData: SCHEDULE,
                isNew
            });
            // 存入缓存
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'currentMenu',
                value: currentMenu,
            })
            // 获取菜单
            this.getServiceData(currentMenu, newMenu);

        } catch (error) {
            console.log(error);
        }
    }


    /**
     * 获取公告图片
     */
    public getnoticeImg = async () => {
        let noticeData: Array<NoticeData> = [];
        // 服务器地址
        let url = Store.getState().serverUrl;
        for (let i = 1; i < 6; i++) {
            // 判断图片是否存在
            try {
                const img = `${url}/bulletin/bulletin${i}.jpg`;
                const newImg = await preLoadNginxImage(img, '/bulletin', '');
                if (newImg) {
                    noticeData.push({
                        // id: i,
                        src: newImg,
                        alt: `bulletin${i}`,
                        className: 'asdasd'
                    })
                }
            }
            catch (error) {
                // console.log(error)
            }

        }
        this.setState({ noticeData });
    }

    // *********************
    // 视图区
    // *********************

    render() {
        const { isNew, specialMenu, normalMenu, propagandaData, restaurantInfo, topBannerAnnouncement, noticeData, scheduleData, disabledOrderBtn } = this.state;
        return (
            <div className={`homePage ${this.checkPhoneType()}`} id={'homeMainTop'}>
                {/* 头部区域 */}
                <HeaderBar
                    propagandaData={propagandaData}
                    restaurantInfo={restaurantInfo}
                />
                {/* 主题内容 */}
                <div className={`home-main `}>
                    {/* 顶部公告条 */}
                    {
                        !!topBannerAnnouncement.length &&
                        <div style={{ marginBottom: 30 }}>
                            {
                                topBannerAnnouncement.map((item, index) => {
                                    return (
                                        <div className="topAnnouncementBox" key={index}>
                                            <div className="icon-box">
                                                {this.topBarIcon(item.icon)}
                                            </div>

                                            <div className="announcement-text">{item.value}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }
                    {/* 活动公告图 */}
                    {
                        this.state.isShowActivityBulletinArea &&
                        <div
                            className="notice-main"
                            style={this.noticeAreaWidth ? { height: this.noticeAreaWidth / 2 } : {}}
                            ref={(imgAreaRef) => {
                                const IMG_WIDTH = _.get(imgAreaRef, 'offsetWidth', 0);
                                if (IMG_WIDTH) this.noticeAreaWidth = IMG_WIDTH;
                            }}>
                            <NoticePage activityBulletinCallBack={() => {
                                this.setState({ isShowActivityBulletinArea: false })
                            }} />
                        </div>
                    }
                    {/* 特色菜 Featured dishes */}
                    <div className="featured-dishes marginTop-10">
                        <FeaturedDishes />
                    </div>
                    {/* 菜单 */}
                    <div className="home-menu marginTop-10">
                        <HomeMenuComponent
                            specialMenu={specialMenu}
                            normalMenu={normalMenu}
                        />
                    </div>
                    {/* 公告--就餐指南 */}
                    <div className="guide-main">
                        <DiningGuide />
                        <div className="seeMore">
                            <Button
                                style={{ display: 'flex', flex: 1 }}
                                onClick={() => {
                                    this.setState({ showGuidePic: true })
                                    // Zmage.browsing({
                                    //     set: noticeData,
                                    //     controller: {
                                    //         // 旋转按钮
                                    //         rotate: false,
                                    //         // 翻页按钮
                                    //         flip: true,
                                    //         // 多页指示
                                    //         pagination: true,
                                    //     },
                                    //     hideOnScroll: false,
                                    //     // 预设
                                    //     preset: 'mobile',
                                    //     // 背景色
                                    //     backdrop: "linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 100%)"
                                    // })
                                }}
                            >
                                <div className="Jumplink-bottom">
                                    <div>{i18n.t('auto_open_page_see_more')}</div>
                                </div>
                            </Button>
                        </div>
                        <PhotoSlider
                            images={noticeData.map((item) => ({ src: item.src }))}
                            visible={this.state.showGuidePic}
                            onClose={() => this.setState({ showGuidePic: false })}
                        />
                    </div>

                    {/* 营业时间 */}
                    <div className="opening-hours marginTop-10">
                        <OpeningHoursComponent
                            scheduleData={scheduleData}
                            isNew={isNew}
                        />
                    </div>
                    {/* 宣传媒体 */}
                    <div className="media marginTop-10">
                        <MediaComponent propagandaData={propagandaData} />
                    </div>
                </div>
                {/* 占位盒 */}
                <div
                    style={{
                        height: PHONE_TYPE.indexOf('iPhone') > -1 && PHONE_TYPE.indexOf('Safari') > -1 ? '22.7vh' : '10vh',
                        paddingTop: '1vh'
                    }}
                />
                {/* 底部 */}
                {
                    // createHashHistory().location.pathname !== '/Main' &&
                    <LiteFooterBar
                        specialMenu={specialMenu}
                        normalMenu={normalMenu}
                        disabledOrderBtn={disabledOrderBtn}
                    />
                }
            </div>
        )
    }

}

export default withSnackbar(LiteHomePage);

// **********
// TYPE
// **********

type Props = {

} & WithSnackbarProps

type State = {
    // 普通菜单数据
    normalMenu: Menu;
    // 备选菜单数据
    specialMenu: Array<Menu>;
    isLoading: boolean;
    // 是否开启审核功能
    isApproved: boolean;
    // 自主点餐是否开启
    autonomous: {
        status: boolean
    };
    // 额外费用ID
    menuId: number;
    // 当前桌台状态
    resultTableStatus: TableStatus[];
    // 宣传资料数据
    propagandaData: Array<Propaganda>;
    // 餐馆信息
    restaurantInfo: RestaurantInfo;
    // 首屏顶部公告条
    topBannerAnnouncement: Array<{ id: number; value: string; icon: string; }>;
    // 普通公告图片数据
    noticeData: Array<NoticeData>,
    // 是否显示活动公告
    isShowActivityBulletinArea: boolean;
    // 营业时间数据
    scheduleData: Array<BusinessMenu>;
    // 显示大图
    showGuidePic: boolean;
    // 当前的新营业时间还是旧营业时间
    isNew: Boolean;
    // 禁用《立即点餐》按钮
    disabledOrderBtn: boolean;
}